import { FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_ICON } from "@constants/const/pictures"
import { Category } from "@interfaces/category"
import clsx from "clsx"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import Image from "next/image"
import { FiTrash2 } from "react-icons/fi"
import { Disclosure } from "@headlessui/react"
import { SelectOption } from "@interfaces/misc"
import { FaChevronDown } from "react-icons/fa"
import queryString from "query-string"
import { RadioInput } from "@components/input"

export interface Duration {
  label: string
  value: {
    min_time?: number
    max_time?: number
  }
}

const DURATION = [
  {
    label: "< 1 Jam",
    value: {
      max_time: 1,
    },
  },
  {
    label: "1 - 2 Jam",
    value: {
      min_time: 1,
      max_time: 2,
    },
  },
  {
    label: "2 - 4 Jam",
    value: {
      min_time: 2,
      max_time: 4,
    },
  },
  {
    label: "> 4 Jam",
    value: {
      min_time: 4,
    },
  },
]

interface CategoryRowProps {
  screenWidth: number
  activeCategory: string
  setActiveCategory: (val: string) => void
  duration: string
  setDuration: (val: string) => void
  categories: Category[]
  onClose: () => void
}

export const CategoryRow = ({
  categories,
  activeCategory,
  setActiveCategory,
  setDuration,
  duration,
  onClose,
}: CategoryRowProps) => {
  const router = useRouter()
  const query = router.query
  const { slug } = router.query
  const [showAllCategory, setShowAllCategory] = useState(false)
  const [showAllDuration, setShowAllDuration] = useState(false)
  const [min, setMin] = useState("")
  const [max, setMax] = useState("")

  useEffect(() => {
    const setCategory = () => {
      if (slug) {
        setActiveCategory(slug as string)
      }
    }

    if (categories && categories.length) {
      setCategory()
    }
  }, [slug, categories])

  const handleCategory = (data: Category) => async () => {
    const currentQuery = { ...router.query }
    const categorySlug = data.category_slug
    let newQuery = ""

    if (categorySlug) {
      delete currentQuery.slug
    }

    if (Object.keys(currentQuery).length) {
      const stringify = queryString.stringify(currentQuery)
      newQuery = newQuery + `?${stringify}`
    }

    await router.replace(`/category${categorySlug && `/${categorySlug}`}${newQuery}`)
  }

  const handleDuration = async (o: unknown) => {
    const option = o as SelectOption
    const currentQuery = { ...query }
    const categorySlug = currentQuery.slug

    if (currentQuery.slug) {
      delete currentQuery.slug
    }
    if (currentQuery.min_time) {
      delete currentQuery.min_time
    }
    if (currentQuery.max_time) {
      delete currentQuery.max_time
    }
    setDuration(option.label)
    if (option.value.min_time) {
      currentQuery.min_time = option.value.min_time
    }
    if (option.value.max_time) {
      currentQuery.max_time = option.value.max_time
    }
    const stringify = queryString.stringify(currentQuery)

    let newRoute = "/category"

    if (categorySlug) {
      newRoute += `/${categorySlug}`
    }

    if (stringify) {
      newRoute += `?${stringify}`
    }

    await router.replace(newRoute)
  }

  const handlePrice = async (type: string) => {
    const currentQuery = { ...query }
    const categorySlug = currentQuery.slug

    if (currentQuery.slug) {
      delete currentQuery.slug
    }

    if (type === "min" && min.length) {
      currentQuery.min_price = min
    } else {
      currentQuery.max_price = max
    }
    const stringify = queryString.stringify(currentQuery)

    let newRoute = "/category"

    if (categorySlug) {
      newRoute += `/${categorySlug}`
    }

    if (stringify) {
      newRoute += `?${stringify}`
    }

    await router.replace(newRoute)
  }

  const handleReset = async () => {
    await window.location.replace("/learning/category")
  }

  return (
    <div className={clsx("relative")}>
      <section>
        <FlexBox justify="between" className="border-b-2 border-grey-ec pb-4">
          <FlexBox>
            <div className="sm:hidden my-auto mr-4 font-medium" onClick={onClose}>
              X
            </div>
            <div className="text-lg sm:text-grey-97 font-medium">Filter</div>
          </FlexBox>
          <div
            className="flex gap-2 text-red font-medium my-auto cursor-pointer"
            onClick={handleReset}
          >
            Reset <FiTrash2 className="my-auto" />
          </div>
        </FlexBox>
        <Disclosure defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between lg:font-semibold font-medium py-2 text-left text-green focus:outline-none">
                <FlexBox className="gap-2" align="center">
                  <div className="my-auto">
                    <Image
                      src={`${HARISENIN_PUBLIC_ICON}/icon_teacher.png`}
                      width={14}
                      height={14}
                      className="my-auto"
                      alt="teacher"
                    />
                  </div>
                  <div className="my-auto"> Bidang Studi</div>
                </FlexBox>
                <FaChevronDown
                  className={`${open ? "rotate-180 transform" : ""} h-3 w-3 my-auto`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="text-grey-97 gap-2 flex flex-col">
                {!showAllCategory &&
                  categories.slice(0, 4).map((item, i) => (
                    <RadioInput
                      id={i}
                      fieldValue={item.category_slug}
                      value={activeCategory}
                      name="Bidang Studi"
                      onChange={handleCategory(item)}
                      key={i}
                    >
                      {item.category_name}
                    </RadioInput>
                  ))}

                {showAllCategory &&
                  categories.map((item, i) => (
                    <RadioInput
                      id={i}
                      fieldValue={item.category_slug}
                      value={activeCategory}
                      name="Bidang Studi"
                      onChange={handleCategory(item)}
                      key={i}
                    >
                      {item.category_name}
                    </RadioInput>
                  ))}

                {/* if more than 4 item */}
                {categories.length > 4 && (
                  <div
                    className="flex text-black gap-2 cursor-pointer my-1"
                    onClick={() => setShowAllCategory(!showAllCategory)}
                  >
                    Tampilkan {showAllCategory ? "Sedikit" : "Semua"}
                    <FaChevronDown
                      className={`${showAllCategory ? "rotate-180 transform" : ""} h-2 w-2 my-auto`}
                    />
                  </div>
                )}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <div className="border-b-2 border-grey-ec my-4" />
        <Disclosure defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between lg:font-semibold font-medium py-2 text-left text-green focus:outline-none">
                <FlexBox className="gap-2" align="center">
                  <div className="my-auto">
                    <Image
                      src={`${HARISENIN_PUBLIC_ICON}/icon_wallet.png`}
                      width={14}
                      height={14}
                      className="my-auto"
                      alt="wallet"
                    />
                  </div>
                  <div className="my-auto"> Harga</div>
                </FlexBox>
                <FaChevronDown
                  className={`${open ? "rotate-180 transform" : ""} h-3 w-3 my-auto`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="text-grey-97">
                <FlexBox className="my-2 border-grey-97">
                  <div className="bg-grey-ec p-2 text-black font-medium rounded-l-sm">Rp</div>
                  <input
                    placeholder="Harga Terendah"
                    type="number"
                    className="border border-grey-ec p-2 rounded-r-sm focus:outline-none w-full"
                    onChange={(e) => setMin(e.target.value)}
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                    }
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handlePrice("min")
                      }
                    }}
                  />
                </FlexBox>
                <FlexBox className="my-2 border-grey-97">
                  <div className="bg-grey-ec p-2 text-black font-medium rounded-l-sm ">Rp</div>
                  <input
                    type="number"
                    placeholder="Harga Tertinggi"
                    className="border border-grey-ec p-2 rounded-r-sm focus:outline-none w-full"
                    onChange={(e) => setMax(e.target.value)}
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                    }
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handlePrice("max")
                      }
                    }}
                  />
                </FlexBox>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <div className="border-b-2 border-grey-ec my-4" />

        <Disclosure defaultOpen>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between lg:font-semibold text-base-responsive text-base py-2 text-left text-green focus:outline-none">
                <FlexBox className="gap-2" align="center">
                  <div className="my-auto">
                    <Image
                      src={`${HARISENIN_PUBLIC_ICON}/icon_alarm-clock.png`}
                      width={14}
                      height={14}
                      alt="alarm clock"
                    />
                  </div>
                  <div className="my-auto"> Durasi</div>
                </FlexBox>
                <FaChevronDown
                  className={`${open ? "rotate-180 transform" : ""} h-3 w-3 my-auto`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="text-grey-97">
                {DURATION.map((item, index) => (
                  <div className="flex gap-2 my-1" key={index}>
                    <RadioInput
                      id={item.label}
                      fieldValue={item.label}
                      value={duration}
                      name="duration"
                      onChange={() => handleDuration(item)}
                    >
                      {item.label}
                    </RadioInput>
                  </div>
                ))}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </section>
    </div>
  )
}
